import { render, staticRenderFns } from "./CustomerSOA.vue?vue&type=template&id=9735e2a0&scoped=true"
import script from "./CustomerSOA.vue?vue&type=script&lang=js"
export * from "./CustomerSOA.vue?vue&type=script&lang=js"
import style0 from "./CustomerSOA.vue?vue&type=style&index=0&id=9735e2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9735e2a0",
  null
  
)

export default component.exports